import { render } from "./CallToActionButton.vue?vue&type=template&id=3274f7a2&scoped=true"
import script from "./CallToActionButton.vue?vue&type=script&lang=js"
export * from "./CallToActionButton.vue?vue&type=script&lang=js"

import "./CallToActionButton.vue?vue&type=style&index=0&id=3274f7a2&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3274f7a2"]])

export default __exports__